export default "__VITE_ASSET__BtoEeik9__"